import * as React from 'react'
import { Link } from '@amzn/dvui/dist/Link'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import { roundValue } from '../../utils/numberUtils'
import { withLocalization, LocalizerProps } from '../localizer/localizer'
import * as styles from './amazonRating.module.scss'
import { safeBoolean } from '../../utils/utils'
import * as cn from 'classnames'

export interface IAmazonRatingBadgeProps {
  amazonRating?: WpsRuntime.atv.wps.AmazonRatingProps,
  pageTitleId: string
  isRetail: boolean
  isStarlightEnhanced: boolean
  comingSoonMessagesPresent?: boolean
  isCerberusChild: boolean
}

type LocalizedAmazonRatingProps = IAmazonRatingBadgeProps & LocalizerProps

//TODO(AVWebDP-648): Create new reftags for starlight review links
const createReviewLink = '/review/create-review/ref=acr_dpinstantvideo_solicit?ie=UTF8&asin='
const allReviewsLink = (titleId: string) => `/product-reviews/${titleId}/ref=cm_cr_dp_d_show_all_btm?ie=UTF8&reviewerType=all_reviews`

interface FirstReviewProps {
  titleId: string,
  comingSoonMessagesPresent: boolean,
}

// Given that no reviews are currently present
const BeTheFirstToReview = ({ titleId, comingSoonMessagesPresent }: FirstReviewProps) => {
  if (comingSoonMessagesPresent) {
    return null
  }

  return <Link href={`${createReviewLink}${titleId}`}>
    <TextLocalizer stringID={StringId.DV_DP_first_review} />
  </Link>
}

const AmazonRatingWithLocalization = ({
                                        amazonRating,
                                        pageTitleId,
                                        isRetail,
                                        comingSoonMessagesPresent = false,
                                        getString,
                                        isCerberusChild,
                                        isStarlightEnhanced,
}: LocalizedAmazonRatingProps) => {
  // We don't show Amazon Rating on Fogg and WinApp
  if (!isRetail || global.__NATIVEAPP__) {
    return null
  }
  const rating = amazonRating && amazonRating.value
  const count = amazonRating && amazonRating.count
  const countFormatted = amazonRating && amazonRating.countFormatted

  if (!count || !rating) {
    if (!safeBoolean(isCerberusChild)) {
      return <BeTheFirstToReview titleId={pageTitleId} comingSoonMessagesPresent={comingSoonMessagesPresent}/>
    }
    return null
  }

  const ariaLabel = getString(StringId.DV_DP_ARIA_amazon_rating, {
    ratingValue: roundValue(rating, 10).toString(),
    customerCount: count.toString()
  })

  const value = roundValue(rating, 2)
  const classes = [styles.one, styles.two, styles.three, styles.four]
  const hasHalfStar = Boolean((value * 2) % 2)
  const baseNumber = classes[Math.ceil(value) - 1]
  const ratingLink = isStarlightEnhanced ? allReviewsLink(pageTitleId) : '#customer-review-section'
  return (
    <a href={ratingLink} aria-label={ariaLabel} data-automation-id="customer-review-badge">
        <Icon use={IconType.AMAZON_RATING}
              className={cn(styles.rating, baseNumber, {
                  [styles.hasHalfStar]: hasHalfStar
                }
              )}/>
        <span>&nbsp;({countFormatted})</span>
      </a>
  )
}

export const AmazonRating = withLocalization(AmazonRatingWithLocalization)
